"use client";
import { useInkeepConversation as l } from "../../providers/conversation-provider.js";
import { useChatEvents as r } from "../../providers/chat-events-provider.js";
import { useChatForm as p } from "../../providers/chat-form-provider.js";
import { useModal as a } from "../modal/modal-provider.js";
const v = (o) => {
  const { logEvent: n } = r(), { conversation: e } = l(), { openForm: t } = p(), i = a();
  return { handleAction: (s) => {
    o.action.type === "open_form" ? (s?.onOpenForm?.(), t?.(o.action.formSettings)) : o.action.type === "invoke_callback" && (o.action.callback({
      conversation: e
    }), o.action.shouldCloseModal && i?.setOpen(!1));
  }, logHelpAction: () => {
    !("name" in o) || !e.id || n({
      eventName: "get_help_option_clicked",
      properties: {
        getHelpOption: o,
        conversation: e
      }
    });
  } };
};
export {
  v as useChatAction
};
